<div class="copilot-panel-wrapper">
  <div class="copilot-panel-inner">
    <div class="copilot-panel-container" #copilotPanel>
      <div class="copilot-panel-content">
        <!-- Header -->
        <div class="panel-header">
          <div class="header-left">
            <div class="copilot-icon">
              <img src="../../../assets/icons/sidebar/star-active.svg" height="20" alt="copilot" />
            </div>
            <span class="panel-title">Copilot</span>
          </div>
          <div class="header-actions">
            @if (messages.length > 0) {
            <button class="clear-btn" (click)="clearChat()" title="Clear chat">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M4 7l16 0" />
                <path d="M10 11l0 6" />
                <path d="M14 11l0 6" />
                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
              </svg>
            </button>
            } @if (false) {
            <button class="expand-btn" (click)="toggleExpand()" [title]="isExpanded ? 'Collapse' : 'Expand'">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                @if (!isExpanded) {
                <ng-container>
                  <path d="M15 3h6v6" />
                  <path d="M9 21H3v-6" />
                  <path d="M21 3l-7 7" />
                  <path d="M3 21l7-7" />
                </ng-container>
                } @if (isExpanded) {
                <ng-container>
                  <path d="M8 3v3a2 2 0 0 1-2 2H3" />
                  <path d="M16 21v-3a2 2 0 0 1 2-2h3" />
                  <path d="M3 8l4-4" />
                  <path d="M21 16l-4 4" />
                </ng-container>
                }
              </svg>
            </button>
            }
            <img
              class="close-panel"
              src="../../../assets/icons/close.svg"
              height="16"
              alt="close"
              (click)="closePanel()"
            />
          </div>
        </div>

        <!-- Chat Body -->
        <div class="panel-body">
          <!-- Welcome & Recommended Prompts (shown when no messages) -->
          @if (messages.length === 0) {
          <div class="welcome-section">
            <div class="welcome-header">
              <div class="welcome-icon">
                <img src="../../../assets/icons/sidebar/star-ai.svg" height="40" alt="copilot" />
              </div>
              <h2>How can I help you today?</h2>
              <p>Ask me anything about your store, sales, customers, or inventory.</p>
            </div>
            <div class="recommended-prompts">
              <div class="prompts-pills">
                @for (prompt of recommendedPrompts; track prompt) {
                <div class="prompt-pill" (click)="selectPrompt(prompt)">
                  {{ prompt.prompt }}
                </div>
                }
              </div>
            </div>
          </div>
          }

          <!-- Messages (shown when there are messages) -->
          @if (messages.length > 0) {
          <div class="messages-container">
            @for (message of messages; track message) {
            <div class="message" [ngClass]="message.type">
              @if (message.type === 'assistant') {
              <div class="message-avatar">
                <img src="../../../assets/icons/sidebar/star-active.svg" height="16" alt="copilot" />
              </div>
              }
              <div class="message-content">
                <span>{{ message.content }}</span>
              </div>
            </div>
            }
            <!-- Loading indicator -->
            @if (isLoading) {
            <div class="message assistant">
              <div class="message-avatar">
                <img src="../../../assets/icons/sidebar/star-active.svg" height="16" alt="copilot" />
              </div>
              <div class="message-content loading">
                <div class="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
            }
          </div>
          }
        </div>

        <!-- Input Area -->
        <div class="input-area">
          <div class="input-container">
            <textarea
              [(ngModel)]="userMessage"
              (keypress)="onKeyPress($event)"
              placeholder="Ask me anything..."
              rows="1"
              class="message-input"
            ></textarea>
            <button class="send-btn" (click)="sendMessage()" [disabled]="!userMessage.trim() || isLoading">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M10 14l11 -11" />
                <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
